import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CustomBanner = ({ linkUrl, bgImage, styles = {} }) => {
  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <Link to={linkUrl}>
          <img
            src={bgImage}
            style={{ width: "100%", height: "auto", ...styles }}
          />
        </Link>
      </div>
    </>
  );
};

export default CustomBanner;
